import React from 'react';
import RelayService from '../../service/RelayService';
import { QueryRenderer, graphql } from 'react-relay';
import LeadSurvey from './LeadSurvey';

export default class LeadSurveyLoader extends React.Component {

  render() {
    return (
      <QueryRenderer
        environment={RelayService.environment}
        query={graphql`
            query LeadSurveyLoaderQuery($leadType: String) {
                viewer {
                    ...LeadSurvey_viewer @arguments(leadType: $leadType)
                }
            }
          `}
        variables={{
          leadType: 'INQUIRY_PRODUCT',
        }}
        render={({ error, props }) => {
          if (error) {
            return <div>{error.message}</div>;
          } else if (props && props.viewer) {
            return (
              <LeadSurvey viewer={props.viewer} />
            )
          }
          return <div>Loading</div>
        }
        }
      >
      </QueryRenderer>
    )
  }
}
